import { GRAD } from "../../../Constants";
import ProfileModal from "../../TransporterClientScreen/ProfileModal/ProfileModal";
import styles from "./SpotDashboard.module.css";

export function HBarChart({ labels, data, gradKey = "sky", prefix = "", suffix = "", profileModalItems = null, visibleBars = null, isFullScreen = false }) {
  if (!data.length) {
    return <div className={styles["sd-empty-chart"]}>No data Available</div>;
  }

  const colors = GRAD[gradKey] || GRAD.sky;
  const max = Math.max(...data.map(Number), 1) * 1.06;
  const VW = isFullScreen ? 900 : 400;
  const LABEL_H = isFullScreen ? 17 : 19;
  const BAR_H = isFullScreen ? 24 : 28;
  const ROW_H = LABEL_H + BAR_H;
  const ROW_GAP = isFullScreen ? 6 : 8;
  const PL = 6;
  const PR = 6;
  const PT = 4;
  const PB = 4;
  const VH = PT + data.length * ROW_H + Math.max(0, data.length - 1) * ROW_GAP + PB;
  const chartW = VW - PL - PR;

  const isScrollable = visibleBars !== null && data.length > visibleBars;
  const VH_visible = isScrollable
    ? PT + visibleBars * ROW_H + Math.max(0, visibleBars - 1) * ROW_GAP + PB
    : VH;

  return (
    <div
      className={isScrollable ? styles["sd-hbar-scroll-wrap"] : styles["sd-hbar-wrap"]}
      style={
        isScrollable
          ? {
            width: "100%",
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
          }
          : { width: "100%" }
      }
    >
      <svg
        viewBox={`0 0 ${VW} ${VH}`}
        className={styles["sd-hbar-svg"]}
        preserveAspectRatio="xMidYMid meet"
        style={
          isScrollable
            ? {
              width: "100%",
              height: "auto",
              minHeight: "100%",
              display: "block",
            }
            : { width: "100%", height: "auto", display: "block" }
        }
      >
        {data.map((rawValue, index) => {
          const value = Number(rawValue || 0);
          const barWidth = (value / max) * chartW;
          const rowY = PT + index * (ROW_H + ROW_GAP);
          const barY = rowY + LABEL_H;
          const color = colors[index % colors.length];
          const display = `${prefix}${value.toFixed(2)}${suffix}`;
          const inside = barWidth > 85;

          return (
            <g key={`${labels[index]}-${index}`}>
              {profileModalItems?.[index]?.transporter_id ? (
                <foreignObject
                  x={PL}
                  y={rowY}
                  width="230"
                  height={LABEL_H}
                >
                  <div className={styles["sd-hbar-profile-label"]}>
                    <ProfileModal
                      transporter_list={profileModalItems}
                      transporter_id={profileModalItems[index].transporter_id}
                      transporter_name={profileModalItems[index].transporter_name}
                      screenName="LoRRI Adhoc Dashboard"
                      moduleName="LoRRI Adhoc"
                      style={{
                        fontSize: "13px",
                        color: "#2B2A29",
                        fontWeight: "600",
                        padding: "0px",
                        margin: "0px",
                      }}
                    />
                  </div>
                </foreignObject>
              ) : (
                <text
                  x={PL}
                  y={rowY + LABEL_H - 4}
                  textAnchor="start"
                  fontSize="13"
                  fontWeight="600"
                  fill="#2B2A29"
                >
                  {labels[index]}
                </text>
              )}
              <rect x={PL} y={barY} width={barWidth} height={BAR_H} fill={color} rx="4" />
              <text
                x={inside ? PL + barWidth - 8 : PL + barWidth + 6}
                y={barY + BAR_H / 2}
                textAnchor={inside ? "end" : "start"}
                dominantBaseline="middle"
                fontSize="12"
                fontWeight="700"
                fill={inside ? "#FEFEFE" : color}
              >
                {display}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}